import { accountConfig } from "@account/configs";
import { evaluateConfig } from "@crystal/core";
import { createGlassHttp } from "@crystal/glass-bridge";
import { ApiError } from "@crystal/http";
import { getToken } from "@crystal/recaptcha";
import { FrontendName } from "../monitoring.js";
import { LoginError, LoginErrors } from "./login-types.js";
async function login(credentials) {
  const { post } = createGlassHttp({
    clientTag: FrontendName
  });
  const { recaptchaSiteKey } = evaluateConfig(accountConfig);
  try {
    const body = {
      ...credentials,
      recaptcha: await getToken(recaptchaSiteKey, {
        action: "login"
      })
    };
    return await post("/api/account/login", body);
  } catch (err) {
    if (err instanceof ApiError) {
      const { isKMCRequired, isTemporarilyLocked, isUserBlocked, validationErrors } = getErrorDetails(err);
      return Promise.reject(
        new LoginError(err, {
          isKMCRequired,
          isTemporarilyLocked,
          isUserBlocked,
          validationErrors,
          details: err
        }).serialize()
      );
    }
    return Promise.reject(
      new LoginError(err, {
        details: err
      }).serialize()
    );
  }
}
const loginApi = {
  login
};
function getErrorDetails(error) {
  if (error.statusCode !== 400 && error.statusCode !== 409) {
    return {};
  }
  const validationErrors = error.details.validationErrors;
  const error_description = validationErrors == null ? void 0 : validationErrors.error_description;
  const isUserBlocked = [LoginErrors.ACCOUNT_ACCESS_LOCKED, LoginErrors.ACCOUNT_LOCKED_CCI].includes(error_description);
  const isTemporarilyLocked = error_description === LoginErrors.ACCOUNT_LOCKED;
  const isKMCRequired = error_description === LoginErrors.KR_CI_REQUIRED;
  return {
    isUserBlocked,
    isTemporarilyLocked,
    isKMCRequired,
    validationErrors
  };
}
export {
  loginApi
};
//# sourceMappingURL=login.js.map
